class Configuration {
	static get PROTOCOL() {
		return 'http://';
	}

	static get HOST_BACK() {
		return `${this.PROTOCOL}www.asturiascongresos.com/`;
	}
	static get HOST_FRONT() {
		return `${this.PROTOCOL}www.asturiascongresos.com/`;
	}

	static get WEB_ROOT() {
		return 'embajadores-landing/';
	}
	static get WEB_ROOT_FRONT() {
		return `${this.WEB_ROOT}`;
	}
	static get BASE() {
		return `${this.HOST_BACK}${this.WEB_ROOT}`;
	}

	static get URL_FORM() {
		return `${this.BASE}`;
	}
	static get ENDPOINT_URL() {
		return `${this.BASE}admin/api/1.0/`;
	}

	static get WEB_PATH() {
		return `${this.HOST_FRONT}${this.WEB_ROOT_FRONT}`;
	}
	static get SITE_NAME() {
		return 'Embajadores Landing';
	}

	static get RESOURCES_DIR() {
		return 'resources/';
	}
	static get RESOURCES_URL() {
		return `${this.WEB_PATH}${this.RESOURCES_DIR}`;
	}

	static get social_networks() {
		return [
			{
				name: 'twitter',
				icon: 'twitter'
			},
			{
				name: 'facebook',
				icon: 'facebook-f'
			},
			{
				name: 'youtube',
				icon: 'youtube'
			},
			{
				name: 'linkedin',
				icon: 'linkedin'
			}
		];
	}

	static get pages() {
		return [ 'home', 'aviso-legal', 'politica-cookies' ];
	}

	static get urlPages() {
		return this.pages.map((value) => `/${value}`);
	}

	static urls(...selUrls) {
		var urls = [];
		urls['site-properties'] = 'site-properties';
		urls['home'] = 'url/home';
		urls['politica-cookies'] = 'url/politica-cookies';
		urls['aviso-legal'] = 'url/aviso-legal';
		if (selUrls.length > 0) {
			var resUrls = [];
			selUrls.forEach((value) => {
				resUrls[value] = urls[value];
			});
			return resUrls;
		} else {
			return urls;
		}
	}
}

export default Configuration;
